import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThemeProvider from './utils/ThemeContext';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import FinancialIntelligence from './pages/FinancialIntelligence';
import RiskAssessment from './pages/RiskAssessment';
import FraudDetection from './pages/FraudDetection';
import ConsumptionInsights from './pages/ConsumptionInsights';
import Profile from './pages/Profile';
import Saved from './pages/Saved';
import Settings from './pages/Settings';
import Finances from './pages/Finances';
import UserDataProvider from './utils/UserDataContext';
import AccountSecurity from './pages/AccountSecurity';
import { LanguageProvider } from './utils/languageContext';
  

function App() {
  return (
    <ThemeProvider>
      <UserDataProvider>
        <LanguageProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/finances" element={<Finances />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/saved" element={<Saved />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/financial-intelligence" element={<FinancialIntelligence />} />
              <Route path="/risk-assessment" element={<RiskAssessment />} />
              <Route path="/fraud-detection" element={<FraudDetection />} />
              <Route path="/account-security" element={<AccountSecurity />} />
              <Route path="/consumption-insights" element={<ConsumptionInsights />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </LanguageProvider>
      </UserDataProvider>
    </ThemeProvider>
  );
}

export default App;
